export default {
    dashboardWidgetItem: {
      list: "Dashboard Widget Item List",
      update: "Dashboard Widget Item Detail",
      create: "Dashboard Widget Item Detail",
    },
  }